import { ELocale, DomainTranslations } from 'App/i18n/i18n.types';

import esAR from './upsell.es-AR.json';
import esMX from './upsell.es-MX.json';
import ptBR from './upsell.pt-BR.json';

const commonTranslations: DomainTranslations = {
  name: 'upsell',
  languages: {
    [ELocale.ARGENTINA]: esAR,
    [ELocale.MEXICO]: esMX,
    [ELocale.BRAZIL]: ptBR
  }
};

export default commonTranslations;
